import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_feasibility-hub-10/artifacts/nb8rpfwp_Ruam%20Architects%20Logo.jpg";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-brand-dark text-white/60 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Raum Architects" className="w-12 h-12 rounded-full object-cover ring-1 ring-white/20" />
              <h3 className="font-heading text-2xl font-semibold text-white tracking-wider">RAUM</h3>
            </div>
            <p className="text-brand-accent text-sm font-heading italic mb-3">We create space.</p>
            <p className="text-sm leading-relaxed">
              Architecture reimagined for South Africa. Data-driven decisions, world-class design.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h4 className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-brand-accent mb-4">Interactive Tools</h4>
            <div className="space-y-2.5">
              <Link to="/feasibility" className="block text-sm hover:text-white transition-colors">Project Feasibility</Link>
              <Link to="/cost-calculator" className="block text-sm hover:text-white transition-colors">Cost Calculator</Link>
              <Link to="/brief-builder" className="block text-sm hover:text-white transition-colors">Brief Builder</Link>
              <Link to="/architect" className="block text-sm hover:text-white transition-colors">Guided Consultation</Link>
              <Link to="/fit-score" className="block text-sm hover:text-white transition-colors">Fit Score</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-brand-accent mb-4">Practice</h4>
            <div className="space-y-2.5">
              <Link to="/projects" className="block text-sm hover:text-white transition-colors">Our Projects</Link>
              <Link to="/about" className="block text-sm hover:text-white transition-colors">About Us</Link>
              <span className="block text-sm">Gauteng, South Africa</span>
              <span className="block text-sm">info@raumarchitects.co.za</span>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-brand-accent mb-4">Legal</h4>
            <div className="space-y-2.5">
              <span className="block text-sm">Privacy Policy</span>
              <span className="block text-sm">Terms of Service</span>
              <span className="block text-sm">SACAP Registered</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs">&copy; {new Date().getFullYear()} Raum Architects. All rights reserved.</p>
          <p className="text-xs text-white/30">Powered by Architecture Engine v1</p>
        </div>
      </div>
    </footer>
  );
}
